
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise-resource-planning-software-services",
      function () {
        return require("private-next-pages/enterprise-resource-planning-software-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise-resource-planning-software-services"])
      });
    }
  